export default {
    data() {
        return {
            sese: '客服信息:<br>4008-032-321<br>周一~周五 08:30-17:30<br>13535300254<br>周一~周五 17:30-22:00<br>周六~周日 10:00-22:00<br>客服QQ：<a href="http://sighttp.qq.com/msgrd?v=1&uin=1848331480">1848331480</a>客服QQ：<a href="http://sighttp.qq.com/msgrd?v=1&uin=645524520">645524520</a>',
            isWidth: '',
            courseNavigation: [{
                id: '',
                parent_id: '',
                name: '',
            }
            ],
            labels: {
                id: '0'
            },
            courseType: [{
                id: '1',
                name: '专技继教'
            },
            {
                id: '2',
                name: '精品课程'
            },
            {
                id: '3',
                name: '热门课程'
            },
            {
                id: '4',
                name: '名师课程'
            },
            {
                id: '5',
                name: '选修课程'
            },
            ],
            sliderImgs: [],
            recommendCourseImg: [],
            // sections:[{
            //     id: '',
            //     name: "1233",
            //     page: '',
            //     shop_id: '',
            //     sort: '',
            //     template: '',
            //     classDetails: [{
            //         period: '123',
            //         image: '',
            //         name: '1111',
            //         price: '',
            //         onsale:'',
            //         teacher: ' ',
            //         desc: '',
            //         section_id:'',
            //     }]
            // }]
            sections: [],
            classDetails: {
                period: '',
                image: '',
                name: '',//
                price: '',
                onsale: '',
                teacher: ' ',
                desc: '',
                project_id: '',
            },
            courseNavFa: {
                fa0: 'iconfont icon-xueshimao',
                fa1: 'iconfont icon-dianzixinxi',
                fa1: 'iconfont icon-dianzixinxi',
                fa2: 'iconfont icon-guanli',
                fa3: 'iconfont icon-yishushejichuanmei',
                fa4: 'iconfont icon-zhizao',
                fa5: 'iconfont icon-diannao',
                fa6: 'iconfont icon-jiaotongyunshu',
                fa7: 'iconfont icon-icon-qita',
            },
            // 地区列表
            regionList: [
                {
                    id: 1,
                    name: '廉江市',
                    isShow: true
                },
                {
                    id: 2,
                    name: '广州市',
                    isShow: false
                },
                {
                    id: 3,
                    name: '茂名市',
                    isShow: false
                }
            ],
            // 项目列表
            projectList: [
                {
                    id: 1,
                    region: '广州',
                    status: '报名中',
                    title: '广东省2017年“强师工程”——中小学骨干校长高级研修项目'
                },
                {
                    id: 2,
                    region: '廉江',
                    status: '学习中',
                    title: '广东省2017年“强师工程”——中小学骨干校长高级研修项目'
                },
                {
                    id: 3,
                    region: '茂名',
                    status: '报名中',
                    title: '广东省2017年“强师工程”——中小学骨干校长高级研修项目'
                },
                {
                    id: 4,
                    region: '深圳',
                    status: '学习中',
                    title: '广东省2017年“强师工程”——中小学骨干校长高级研修项目'
                },
                {
                    id: 5,
                    region: '佛山',
                    status: '已完成',
                    title: '广东省2017年“强师工程”——中小学骨干校长高级研修项目'
                },
                {
                    id: 6,
                    region: '珠海',
                    status: '已完成',
                    title: '广东省2017年“强师工程”——中小学骨干校长高级研修项目'
                }
            ],
            // 新闻列表
            newsList: [
                '中央政府门户网站：知行中国-中小学班主任教师国家级远程培训班开班sssssssssssssss',
                '中国教育新闻网："知行中国—中小学班主任国家级远程培训"开班',
                '光明日报：10万班主任参加“知行中国”远程培训',
                '中国新闻网：中国将远程培训10万名小学一线班主任教师',
                '中国教育报：问题解决让远程研修更接地气',
                '【中国教育报】信息技术与教师培训深度融合'
            ],
            // 通知列表
            informList: [
                {
                    id: 1,
                    year: '2019',
                    time: '12.18',
                    title: '中央财政下达19.85亿元，用于乡村中小幼教师培训'
                },
                {
                    id: 2,
                    year: '2019',
                    time: '12.18',
                    title: '聚焦！4月18日-19日，第十届长三角基础教育课程与教学改革论坛即将召开'
                },
                {
                    id: 3,
                    year: '2019',
                    time: '12.18',
                    title: '全国中小学教师信息技术应用能力提升工程2.0启动'
                }
            ]
        }
    },
    computed: {
        
    },
    methods: {
        // //跳转到项目首页
        // toProjectHomePage(id){
        //     this.$router.push({
        //         path:'/pojecthomepage',
        //         query:{
        //             id : id
        //         }
        //     });
        // },
        // //跳转到项目搜索页面
        // toProjectSearch(){
        //     this.$router.push({
        //         path:'/projectlist'
        //     });
        // },
        // //返回首页
        // toIndex:function(){
        //     this.$router.push({
        //         path:'/'
        //     });
        // },
        // //点击一级标签
        // firstLabel: function (lableData, firstName, firstId) {
        //     this.$router.push({
        //         path: '/classsearch',
        //         query: {
        //             firstName: firstName,
        //             firstId: firstId,
        //             lableData: JSON.stringify(lableData),
        //             lableType: 'firstLable',
        //         }
        //     });
        // },
        // //点击二级标签
        // secondLable: function (lableData, secondId, firstName, secondName, secondIndex,firstId) {        
        //     this.$router.push({
        //         path: '/classsearch',
        //         query: {
        //             firstName: firstName,
        //             secondName: secondName,
        //             lableData: JSON.stringify(lableData),
        //             secondId: secondId,
        //             secondIndex: secondIndex,
        //             lableType: 'secondLable',
        //             firstId:firstId
        //         }
        //     });

        // },
        // //点击三级标签
        // thirdLabel: function (lableData, thirdId, firstName, secondName, thirdName, secondIndex, thirdIndex) {
        //     this.$router.push({
        //         path: '/classsearch',
        //         query: {
        //             firstName: firstName,
        //             secondName: secondName,
        //             thirdName: thirdName,
        //             lableData: JSON.stringify(lableData),
        //             thirdId: thirdId,
        //             secondIndex: secondIndex,
        //             thirdIndex: thirdIndex,
        //             lableType: 'thirdLable',
        //         }
        //     });

        // },
        // toSearch: function () {
        //     this.$post('shops/get_url', { url: window.location.href.split('/#')[0] }).then(res => {
        //         return res.data.result.id;
        //         // console.log(res.data.result.id);
        //     }).then(id=>{
        //         this.$post('products/search', { name: '', shop_id: id, token: this.$store.state.id, offset: 0, length: 999 }).then(res => {
        //         if (res.data.result.data.length !== 0) {
        //             this.$router.push({
        //                 path: '/blank',
        //                 query: {
        //                     data: JSON.stringify(res.data.result.data),
        //                     value: 'classtext'
        //                 }
        //             });
        //         }
        //     })
        //     })
            
        // },
        //点击类别跳转相应的页面
        // toProductType: function (id, index) {
        //     this.$router.push({
        //         path: '/classsearch',
        //         query: {
        //             courseNavigation_id: id,
        //             index: index,
        //             isHome: true
        //         }
        //     });
        // },
        //点击跳转到继续教育全部课程
        // toProductType: function () {
        //     this.$router.push({
        //         path: '/classsearch',
        //         query: {
        //         }
        //     });
        // },
        // //点击课程跳转到课程详情
        // toSection: function (id) {
        //     if (this.$store.state.id) {
        //         this.$post('users/isPay', { product_id: id, token: this.$store.state.id }).then(res => {
                  
        //             if (!res.data.result) {
                   
        //                 this.$router.push({
        //                     path: '/classstudy',
        //                     query: {
        //                         id: id
        //                     }
        //                 });
                  
        //             } else {
               
        //                 this.$router.push({
        //                     path: '/classdetails',
        //                     query: {
        //                         id: id
        //                     }
        //                 });
                       
        //             }
        //         })
        //     } else {
        //         // let address =
        //         this.$router.push({
        //             path: '/classdetails',
        //             query: {
        //                 id: id
        //             }
        //         });
               
        //     }


        // },
        // //获取类别标签
        // getLabel() {
        //     this.$post('labels/all',{shop_id: this.$store.state.store.id}).then(res => {
        //         let data = res.data.result;
        //         this.allLabel(data, this.labels);
        //         //判断是否有三级标签，给一级添加个isWidth属性
        //         for (let one of this.labels.children) {
        //             if (one.children) {
        //                 innter:
        //                 for (let two of one.children) {
        //                     if (two.children) {
        //                         for (let three of two.children) {
        //                             if (three) {
        //                                 one.isWidth = 'true';
        //                                 break innter;
        //                             }

        //                         }
        //                     }
        //                 }
        //             }
        //         }
        //     })
        // },
     
        // //递归处理返回的标签
        // allLabel(data, labelObj) {
        //     for (let i in data) {
        //         if (data[i].parent_id == labelObj.id) {
        //             if (!labelObj.children) {
        //                 labelObj.children = [];
        //             }
        //             labelObj.children.push(data[i]);
        //             this.allLabel(data, data[i]);
        //         }

        //     }
        // },

        //获取首页数据
        // getdata() {
        //     //课程
        //     this.$post('sections/search', { shop_id: '1' }).then(res => {
            
        //         return res.data.result;
        //     })
        //         .then(data => {
        //             let me = this;
        //             for (let val of data) {
        //                 -function (val) {
        //                     me.$post('section_products/search', { section_id: val.id }).then(res1 => {
                  
        //                         for(let i = 0;i<res1.data.result.length;i++){
        //                             if(res1.data.result[i].onsale != '1'){
        //                                 res1.data.result.splice(i,1);
        //                             }
        //                         }
        //                         let obj = {
        //                             id: val.id,
        //                             name: val.name,
        //                             page: val.page,
        //                             shop_id: val.shop_id,
        //                             sort: val.sort,
        //                             template: val.template,
        //                             classDetails: res1.data.result,
        //                         }
        //                         me.sections.push(obj); 
        //                     })
        //                 }(val)
        //             }
        //         })
        //     // 轮播图数据
        //     for (let i = 1; i <= 4; i++) {
        //         this.$post('products/get', { id: i }).then(res => {
        //             res.data.result.id = i;
        //             this.sliderImgs.push(res.data.result);
        //             this.recommendCourseImg.push(res.data.result);
        //         })
        //     }
        // },

        //获取项目包列表
        // getPackage() {
        //     this.$post('package/search',{
        //         offset:0,
        //         length:9999
        //     }).then(res => {
        //         this.projectList = res.data.result.data
        //         console.log('项目包列表',res.data.result.data)
        //     })
                
        // },
        // 计算状态
        // state(start_stydy_time,end_study_time){
        //     let time = new Date().getTime()
        //     if(time > end_study_time){
        //         return "已完成"
        //     }else if(time < end_study_time && time > start_stydy_time){
        //         return "学习中"
        //     }else{
        //         return "报名中"
        //     }
        // },

    },
    // mounted: function () {
    //     this.getPackage();
    //     this.getLabel();
    //     this.getdata();
    //     document.title='广东人才培训网项目式';    
    // }
}


